export default __webpack_public_path__ + "static/celestial2-880a293442e93ecf12d246ebbea8f2dd.png";